module.exports = __webpack_public_path__ + "img/logo_midelfin.85b765f4.png";